/*
 * Logic to ignore specific called out warnings from cluttering the logs by overriding the console.error method
 *
 * Note: Currently done at the app level, but wonder if this could be enhanced to override console.error on component mount,
 * and then reset to the original on component unmount
 */

export default () => {
  const ignoreWarnings = [
    'Warning: findDOMNode is deprecated and will be removed in the next major release.',
    'Warning: Failed %s type: %s%s',
    'Warning: %s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release.'
  ]

  const origConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0];

    let messageInIgnoreList = false;
    ignoreWarnings.forEach(ignoreWarning => {
      if (message.indexOf(ignoreWarning) > -1) {
        messageInIgnoreList = true;
      }
    });

    if (!messageInIgnoreList) {
      origConsoleError(...args);
    }
  }
}